
    <!-- this.configService.siteName == 'KKU'  else no kku-->
<ng-container *ngIf="siteName == 'KKU' || siteName == 'KMITL' ">
  <div class="mb-5 a-walai text-center form-signin" >
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-3">{{'Single Sign On'|translate}}</p>
  </div>
</ng-container>





<main *ngIf="siteName != 'KKU' && siteName != 'KMITL' " class="form-signin vh-signin">
  <form [formGroup]="loginForm" class="mt-5">
    <div class="mb-5 a-walai text-center" [routerLink]="['/home']">
      <img src="{{ logo }}"
      onError="this.src='assets/images/logo_default.png'" 
      alt="Logo" class="float-left mb-2 mt-4" style="max-width: 40px;">
      <h4 class="ml-5 text-walai-default-color">{{'login'|translate}}</h4>
    </div>
    <div class="form-floating mb-2">
      <input type="text" class="form-control"  formControlName="username" id="floatingInput" placeholder="{{userLogin|translate}}">
      <label for="floatingInput">{{userLogin|translate}}</label>
    </div>

    <div class="form-floating mb-2 position-relative">
      <input [type]="passwordFieldType" autocomplete="off" class="form-control" id="floatingPassword" placeholder="Password" formControlName="password">
      <label for="floatingPassword">{{'Password'|translate}}</label>
      <button type="button" class="btn position-absolute top-50 end-0 translate-middle-y" (click)="togglePasswordVisibility()">
        <i [ngClass]="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa  fa-eye-slash'"></i>
      </button>
    </div>

    <!-- <div class="form-floating mb-1">
      <input type="password" class="form-control" id="floatingPassword" placeholder="Password" formControlName="password">
      <label for="floatingPassword">{{'Password'|translate}}</label>
    </div> -->

   
    <!-- <button class="w-100 btn btn-lg btn-primary" type="submit">Sign in</button> -->

    <div *ngIf="sitename == 'MOJ'" class="alert alert-warning">
      <p>การใช้งานระบบห้องสมุดจะต้องมีการยืนยัน PDPA โดยผู้ใช้งานสามารถดาวน์โหลดเอกสารได้จาก 
        <a [href]="pdpaUrl" [hidden]="pdpaUrl == null || pdpaUrl  == ''" class="text-primary"  role="button" target="_blank" rel="Privacy Policy">
          เอกสารแสดงความยินยอม (Consent Form)</a>
      </p>
      <p class="mt-1"> เมื่อดำเนินการกรอกข้อมูลเรียบร้อยให้ส่งเอกสารไปที่ 
        <span class="text-primary">{{EmailContact}} *</span>
      </p>
      <p class="text-danger">สำหรับห้องสมุดกระทรวงยุติธรรมเท่านั้น***</p>
    
    </div>


    <div class="text-center mt-2">
        <button  class="btn btn-primary btn-lg px-5 mb-2" (click)="clickLogin()" [disabled]="!loginForm.valid" disabled *ngIf="Onlogin==false">{{'login'|translate}}</button>
        <button class="btn btn-primary btn-lg px-5 mb-2" type="button" disabled *ngIf="Onlogin">
          <span class="spinner-border text-warning mr-2" role="status" aria-hidden="true" *ngIf="Onlogin"></span>
          {{'login'|translate}}
        </button>

          <a class="dropdown-item a-hover a-walai" (click)="help()">{{'Help'|translate}}</a>
      <!-- <span><a class="dropdown-item a-hover" [routerLink]="['/Forgotpassword']">{{'ForgotPassword'|translate}}?</a></span>  -->
    </div>


  
  </form>
</main>

